import React from 'react';
import { EllipsisText } from '@monavate/ui-core';
import { camelCaseToCapitalizedString } from '@/helpers/table';
import { SecondaryItem, TableTag } from '@/pages/transactions/TransactionsListPage';
import { Transaction } from '@/api/general';
import styled from 'styled-components';

const IconBank = styled.span`
    background: ${(props) => props.theme['Categorical/2/bg']};
    color: ${(props) => props.theme['Content/primary']};
    display: flex;
    padding: 12px;
    width: 25px;
    gap: 10px;
    float: left;
    margin-right: 10px;
`;

const IconCard = styled.span`
    background: ${(props) => props.theme['Categorical/6/bg']};
    color: ${(props) => props.theme['Content/primary']};
    display: flex;
    padding: 12px;
    width: 25px;
    gap: 10px;
    float: left;
    margin-right: 10px;
`;

interface TransactionInfoRowProps {
    transaction: Transaction;
}

const TransactionInfoRow: React.FC<TransactionInfoRowProps> = ({ transaction }) => {
    const { id, type, bankTransaction, cardTransaction } = transaction;
    return (
        <div>
            {type === 'bank' ? (
                <IconBank>
                    <span className="material-symbols-sharp icon">account_balance</span>
                </IconBank>
            ) : (
                <IconCard>
                    <span className="material-symbols-sharp icon">credit_card</span>
                </IconCard>
            )}
            <EllipsisText style={{ height: '22px' }}>{id}</EllipsisText>
            <SecondaryItem>
                {type === 'bank' ? (
                    <>
                        <TableTag>
                            {camelCaseToCapitalizedString(
                                bankTransaction?.bankTransactionType || '',
                            )}
                        </TableTag>
                        <TableTag>{bankTransaction?.paymentType}</TableTag>
                    </>
                ) : (
                    <>
                        <TableTag>
                            {/*ToDo change when BE fixed key*/}
                            {camelCaseToCapitalizedString(
                                cardTransaction?.type === 'authorization'
                                    ? 'authorisation'
                                    : cardTransaction?.type || '',
                            )}
                        </TableTag>
                        {cardTransaction?.incremental && <TableTag>Incremental</TableTag>}
                        {cardTransaction?.refundAuth && <TableTag>Refund</TableTag>}
                    </>
                )}
            </SecondaryItem>
        </div>
    );
};

export default TransactionInfoRow;
